var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1467 8.77778C10.2 9.56889 10.3333 10.3422 10.5467 11.08L9.48 12.1467C9.11556 11.08 8.88444 9.95111 8.80444 8.77778H10.1467ZM18.9111 19.4622C19.6667 19.6756 20.44 19.8089 21.2222 19.8622V21.1867C20.0489 21.1067 18.92 20.8756 17.8444 20.52L18.9111 19.4622ZM11 7H7.88889C7.4 7 7 7.4 7 7.88889C7 16.2356 13.7644 23 22.1111 23C22.6 23 23 22.6 23 22.1111V19.0089C23 18.52 22.6 18.12 22.1111 18.12C21.0089 18.12 19.9333 17.9422 18.9378 17.6133C18.8489 17.5778 18.7511 17.5689 18.6622 17.5689C18.4311 17.5689 18.2089 17.6578 18.0311 17.8267L16.0756 19.7822C13.56 18.4933 11.4978 16.44 10.2178 13.9244L12.1733 11.9689C12.4222 11.72 12.4933 11.3733 12.3956 11.0622C12.0667 10.0667 11.8889 9 11.8889 7.88889C11.8889 7.4 11.4889 7 11 7Z",
    fill: "#733FE7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    stroke: "#733FE7",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ec025799.svg";
export { ForwardRef as ReactComponent };